import {useCallback} from 'react'
import {useAuth} from '../../auth/hooks/useAuth'

export const useDashboardHelpers = () => {
  const {user, userCanReadFeature} = useAuth()

  const canViewAllWidgets = useCallback(() => {
    return user?.isAdmin || userCanReadFeature('DASHBOARD')
  },[user?.isAdmin, userCanReadFeature])

  const canViewQualificatorWidget = useCallback(() => {
    return userCanReadFeature('QUALIFICATOR')
  }, [userCanReadFeature])

  const canViewExpertWidget = useCallback(() => {
    return userCanReadFeature('EXPERT')
  }, [userCanReadFeature])

  const canViewJuryWidget = useCallback(() => {
    return userCanReadFeature('JURY')
  }, [userCanReadFeature])

  return {
    canViewQualificatorWidget,
    canViewAllWidgets,
    canViewExpertWidget,
    canViewJuryWidget,
  }
}
